// Copyright © 2019-2026 Focal Systems. All rights reserved.

import { iso31661 } from "iso-3166";

/** Official ISO 3166-1 English short names, sorted alphabetically. Stored verbatim in the backend. */
export const COUNTRIES: readonly string[] = iso31661
  .filter((entry) => entry.state === "assigned")
  .map((entry) => entry.name)
  .sort((a, b) => a.localeCompare(b));

export const COUNTRY_OPTIONS: readonly { label: string; value: string }[] = COUNTRIES.map((name) => ({
  label: name,
  value: name,
}));
